export default "__VITE_ASSET__ByGjlX7c__"